"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = arrayAddHandler;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _triggerone = _interopRequireDefault(require("../../trigger/_triggerone"));

var _foreach = _interopRequireDefault(require("../../_helpers/foreach"));

// the function is called when something is added to an array
// it delegates asterisk listener for newly added items
function arrayAddHandler(_ref) {
  var added = _ref.added;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _triggerone["default"].latestEvent.info.delegatedData,
      path = _ref2.path,
      name = _ref2.name,
      callback = _ref2.callback,
      context = _ref2.context,
      info = _ref2.info;

  (0, _foreach["default"])(added, function (item) {
    if (item && (0, _typeof2["default"])(item) === 'object') {
      var delegateListener = require('./')["default"]; // fixing circular ref


      delegateListener(item, path, name, callback, context, info);
    }
  });
}
//# sourceMappingURL=arrayaddhandler.js.map